var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollingCalc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.675 13.357h-3.74a7.008 7.008 0 002.012-11.306A6.955 6.955 0 006.997 0c-1.87 0-3.627.728-4.95 2.05a7.008 7.008 0 000 9.9A6.954 6.954 0 006.997 14h6.68a.322.322 0 10-.002-.643zM6.997.643c1.698 0 3.295.662 4.495 1.862a6.364 6.364 0 010 8.99 6.317 6.317 0 01-4.495 1.861 6.316 6.316 0 01-4.495-1.861 6.364 6.364 0 010-8.99A6.315 6.315 0 016.997.643z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.606 3.618H4.243v.894l2.905 2.681-2.905 2.682v.893h5.363v-1.34H6.478l2.234-2.235-2.234-2.235h3.128v-1.34z"
  })));
}
export default SvgRollingCalc;